import React from "react";
import "./footer.scss";
import logo from "../../media/logo.png";

const footer = () => {
  return (
    <div className="container-footer">
      <div className="container-atas">
        <div className="container-logo">
          <img
            className="gambar-logo"
            src={logo}
            alt="logo-citraland-surabaya"
          />
        </div>
        <div className="container-deskripsi">
          <div className="alamat">
            <p>
              Jl. Citra Raya Utama, Lakarsantri, Kec. Lakarsantri, Surabaya,
              Jawa Timur 60219
            </p>
          </div>
          <div className="contact">Contact us : +6282297791381 (Vania)</div>
          <div className="privasi">
            <a href=""> Privacy Police </a>
          </div>
        </div>
      </div>
      <div className="container-bawah">
        CITRALAND UTARA SURABAYA
        <div className="pw">Powered by Linktown</div>
      </div>
    </div>
  );
};

export default footer;
